export default __webpack_public_path__ + "static/media/11.d46862d7.jpg";